import clsx from "clsx";
import React, { HTMLAttributes } from "react";

type TableBodyItemProps = {
    children: React.ReactNode;
    className?: string;
} & HTMLAttributes<HTMLDivElement>;

export default function TableBodyItem(props: TableBodyItemProps) {
    const { children, className, ...rest } = props;

    return (
        <div
            className={clsx(
                "flex flex-col text-slate-700 text-sm font-rocGroteskMedium px-[14px] py-[10px]",
                className && className
            )}
            {...rest}
        >
            {children}
        </div>
    );
}
